module Meevo.Plugins.Register {

    class ClientChangePromptController {

        static $inject = [
            "meevo.components.modal.ModalService", "$mdDialog"
        ];

        public editClientChangeChoice: number;

        constructor(private modalService: Meevo.Components.Modal.IModalService, private $mdDialog) {
            this.editClientChangeChoice = 1;
        }

        continue() {
            this.$mdDialog.hide({ choice: this.editClientChangeChoice });
        }
    }

    angular.module("meevo.plugins.register")
        .controller("meevo.plugins.register.ClientChangePromptController", ClientChangePromptController);
}